<template>
    <div
        class="list-group-item list-group-item-action"
      >
          <div
            class="row no-gutters align-items-center mb-2"
            v-if="value.schedule && value.schedule.clinic_service"
          >
            <div class="col-auto mr-2">
              <div
                v-if="value.schedule.assignee"
                :style="{
                  backgroundImage: `url(${staticUrl}${value.schedule.assignee.photo})`,
                }"
                class="avatar shadow d-inline-block"
                :class="{
                  doconline:
                    value.schedule.assignee &&
                    isOnline(value.schedule.assignee.id),
                }"
              ></div>
            </div>
            <div class="col">
              <strong v-if="value.schedule && value.schedule.clinic_service" class="d-block">
                {{ $t(value.schedule.clinic_service.type) }}
                {{ value.schedule.clinic_service.name[authLocale] }}
              </strong>
              <span v-if="value.schedule.assignee">
                {{ value.schedule.assignee.firstname[authLocale] }}
                {{ value.schedule.assignee.lastname[authLocale] }}
              </span>
            </div>
            <div class="col-12 col-sm-auto text-right">
              <small class="text-nowrap">
                {{ value.start_time | moment("from", "now") }}
                <div>{{ $t(value.status) }}</div>
              </small>
            </div>
          </div>

        <p class="mb-1">{{ $t("caseContains") }}:</p>
        <div>
          <span
            class="badge badge-primary mr-2"
            v-if="value.evidences.length > 0"
          >
            {{ value.evidences.length }} {{ $t("evidences") }}
          </span>
          <span class="badge badge-primary mr-2" v-if="value.files.length > 0">
            {{ value.files.length }} {{ $t("files") }}
          </span>
          <span
            class="badge badge-primary mr-2"
            v-if="value.labtests.length > 0"
          >
            {{ value.labtests.length }} {{ $t("labtests") }}
          </span>
          <span
            class="badge badge-primary mr-2"
            v-if="value.treatments.length > 0"
          >
            {{ value.treatments.length }} {{ $t("treatments") }}
          </span>
          <span class="badge badge-primary mr-2" v-if="value.comment">
            {{ $t("comment") }}
          </span>
          <span class="badge badge-primary mr-2" v-if="value.conclusion">
            {{ $t("conclusion") }}
          </span>
          <span
            class="badge badge-primary mr-2"
            v-if="value.diagnosis && value.diagnosis.length > 0"
          >
            {{ $t("diagnosis") }}
          </span>
        </div>
      </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      isOnline: 'status/isOnline',
      authLocale: 'auth/locale'
    })
  }
}
</script>
<i18n>
{
  "ka": {
    "caseContains": "ჩანაწერი მოიცავს",
    "evidences": "სიმპტომს",
    "files": "ფაილს",
    "labtests": "ლაბორატორიული მონაცემს",
    "treatments": "დანიშნულებას",
    "comment": "კომენტარს",
    "conclusion": "დასკვნას",
    "diagnosis": "დიაგნოზს",
    "telemedicine": "ონლაინ",
    "visit": "კლინიკაში",
    "house_call": "გამოძახება",
    "active": "მიმდინარე",
    "cancelled": "გაუქმებული",
    "completed": "დასრულებული"
  },
  "en": {
    "caseContains": "Case Contains",
    "evidences": "Evidences",
    "files": "Files",
    "labtests": "Labtests",
    "treatments": "Treatments",
    "comment": "Comment",
    "conclusion": "Conclusion",
    "diagnosis": "Diagnosis",
    "telemedicine": "Online",
    "visit": "At Clinic",
    "house_call": "House Call",
    "active": "Active",
    "cancelled": "Cancelled",
    "completed": "Completed"
  }
}
</i18n>
